var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDropWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.5,
    height: 6,
    viewBox: "0 0 11.5 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow-Down_2",
    "data-name": "Arrow-Down 2",
    d: "M15.53,7.444a.607.607,0,0,1,0,.934L10,13.25,4.47,8.378a.607.607,0,0,1,0-.934.823.823,0,0,1,1.061,0L10,11.381l4.47-3.938A.823.823,0,0,1,15.53,7.444Z",
    transform: "translate(-4.25 -7.25)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropWhite);
export default __webpack_public_path__ + "static/media/arrow-drop-white.dcd58a420e8507ad33d0cf4adb0aa9aa.svg";
export { ForwardRef as ReactComponent };